import axios from 'axios';

export const getEventById = async (id) => {
  const response = await axios.get(`/plans/${id}`);

  return response;
};

export const getEventByIdAdmin = async (id) => {
  const response = await axios.get(`/plans/admin/${id}`);

  return response;
};

export const updateEventByIdAdmin = (eventId, data) => axios.put(`/plans/admin/${eventId}`, data);

export const getEvents = async () => {
  const response = await axios.get('plans');

  return response;
};
